import { Subject, Observable } from 'rxjs';
import { SlDialogRef } from './dialog.service';



export interface IDialog {
  /**
   * Closes the dialog.
   */
  close(result?: any): void;

  /**
   * Observable the completes when the dialog is closed. Will contain the optional result of the dialog.
   */
  afterClosed(): Observable<any>;
}

export class DialogRef implements IDialog {
  result?: any;

  closeObservable = new Subject();
  constructor(private dialogRef: SlDialogRef) {
    this.handleAfterHide = this.handleAfterHide.bind(this);
    dialogRef.addEventListener('slAfterHide', this.handleAfterHide);
  }

  close(result?: any): void {
    this.result = result;
    this.dialogRef.setAttribute('open', 'false');
  }

  afterClosed() {
    return this.closeObservable;
  }

  private dispose() {
    if(this.dialogRef.parentElement != null) {
      this.dialogRef.parentElement.removeChild(this.dialogRef);
    }
  }

  private handleAfterHide(e: Event) {
    if (e.target instanceof HTMLElement && (e.target as HTMLElement).tagName === 'SL-DIALOG') {
      this.dispose();
      this.closeObservable.next(this.result);
      this.dialogRef.removeEventListener('slAfterHide', this.handleAfterHide);
    }
  }

}